import { render, staticRenderFns } from "./PublicCouncilBanners.vue?vue&type=template&id=6c4dbfe1&scoped=true&"
import script from "./PublicCouncilBanners.vue?vue&type=script&lang=js&"
export * from "./PublicCouncilBanners.vue?vue&type=script&lang=js&"
import style0 from "./PublicCouncilBanners.vue?vue&type=style&index=0&id=6c4dbfe1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4dbfe1",
  null
  
)

export default component.exports